import React from "react";

import { useTranslation } from "react-i18next";

import Input from "./Input";

import type { JSX } from "react";
import type { Control } from "react-hook-form";

interface NameHeaderInputProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
}

export default function NameHeaderInput({
  control,
}: NameHeaderInputProps): JSX.Element {
  const { t } = useTranslation("editor-errors");
  return (
    <Input
      isRequired
      className="text-[1.875rem] leading-normal font-semibold"
      control={control}
      errorMessage={t("nameIsRequired")}
      name="name"
      type="inline-text"
    />
  );
}
